import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { NumberInlineInput } from '@ztechapps/webui.input'
import { formatMoney } from '@ztechapps/common.utils'

export const OriginalPriceInlineInput = (props: InlineInputProps) => {
  return (
    <NumberInlineInput
      name="originalPrice"
      displayContent={(e) => <div>{formatMoney(e)}</div>}
      validate={(e) => {
        if (e < 0) throw new Error('Price needs to be more than or equal to zero.')
      }}
      label={'Old / Previous Price'}
      help={
        'Usually use this if the product is on sale or discounted. It will be displayed from the webstore too (but with strikethrough), to show the original/previous price. You can leave this empty if the product is not on sale nor discounted.'
      }
      {...props}
    />
  )
}
